import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const http = axios.create({ baseURL: API, withCredentials: true });

http.interceptors.request.use((cfg) => {
  const token = localStorage.getItem("admin_token");
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});

export const inr = (n) =>
  new Intl.NumberFormat("en-IN", { style: "currency", currency: "INR", maximumFractionDigits: 0 }).format(n || 0);

export function apiErr(e) {
  const d = e?.response?.data?.detail;
  if (d == null) return e?.message || "Something went wrong";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return String(d);
}

export const mediaUrl = (u, w) => {
  if (!u) return "";
  if (/^https?:|^data:/.test(u)) return u;
  if (u.startsWith("/api")) return `${BACKEND_URL}${u}${w && u.startsWith("/api/files/") && !u.includes("?") ? `?w=${w}` : ""}`;
  return u;
};

export const mediaSrcSet = (u, widths) =>
  u && u.startsWith("/api/files/") ? widths.map((w) => `${mediaUrl(u, w)} ${w}w`).join(", ") : undefined;

export async function uploadFile(file) {
  const fd = new FormData();
  fd.append("file", file);
  const { data } = await http.post("/admin/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
  return data;
}
